// @erp/module-lib/schemas — the LIB grant matrix. Browser-safe: types + plain
// data only (fe/useCan and the gateway's rbac() evaluate the SAME map through
// can(), so UI affordance and server enforcement can never disagree).
//
// Capability families: desk / catalog / patrons / acq / admin / reports / opac.
// Read-scoped capabilities are their own exact strings ('lib:catalog.read'
// never falls out of 'lib:catalog' — patterns are exact unless ':*').
// Money settlement rides 'lib:fines.settle' — a capability NO role holds
// bare, reachable only through 'lib:*' (librarian/owner/admin), so waiving
// (forgiving) money is exactly the "rides { sensitive: true } routes inside
// 'lib:*'" design; the hard-revoke check guards it too (ADR-000 §9.3). The
// L3 security verify caught the settle route on bare lib:desk — assistants
// could waive fines; the dedicated capability closed that drift. The L4
// verify closed the same drift's second door: POST /memberships/collect with
// method 'Waived' bulk-settles fines for zero cash, so the router's
// requireWaiveTier demands lib:fines.settle there too (cash-equivalent
// methods stay plain lib:desk). Financial reporting is 'lib:reports':
// /memberships/revenue AND its addends /memberships/payments (the L4 verify
// caught the receipts ledger one tier below its own aggregate).
//
// Merge law: compose with the core seed via mergeGrants(ROLE_GRANTS, LIB_GRANTS)
// — NEVER an object spread, which would replace owner/admin's ['core:*'] with
// ['lib:*'] instead of granting both.
import type { RoleGrants } from "@erp/auth-kit/rbac";

export const LIB_GRANTS: RoleGrants = {
  librarian: ["lib:*"],
  owner: ["lib:*"],
  admin: ["lib:*"],
  assistant: ["lib:desk", "lib:catalog.read", "lib:patrons.read"],
  cataloguer: ["lib:catalog", "lib:catalog.read", "lib:acq"],
  data_entry: ["lib:catalog", "lib:catalog.read"],
  patron: ["lib:opac"],
};
